module.exports = {
	message: {
        // 泰国
		home: {
			language: "ภาษาไทย",
			keyword:'คำหลัก',
			hotPro:'ร้อนขายผลิตภัณฑ์',
			product:'ผลิตภัณฑ์หลัก',
			about:'เกี่ยวกับเรา',
			aboutDesc:'ฝ่ายบริการลูกค้าความพึงพอใจของลูกค้า',
			news:'ข่าวล่าสุด',
			company:'บริษัท',
			proVideo:'วิดีโอส่งเสริมการขาย',
			certificate:'ใบรับรอง',
			factory:'โรงงานความร่วมมือ'
		},
		about:{
			advantages:'ข้อดีของเรา',
			factory:'การแสดงผลโรงงาน',
			honors:'ใบรับรองเกียรตินิยม',
			honorsDesc:'เราจะตามเป้าหมายในการรับใช้ท่าน ที่ดีกว่า',
			title1:'กำลังการผลิต',
			content1:'เป็นเจ้าของโรงงานผลิตขนาดใหญ่ ที่ทันสมัย',
			title2:'ราคาแข่งขันได้',
			content2:'ราคาสมเหตุสมผลประสิทธิภาพสูง',
			title3:'การจัดส่ง ที่รวดเร็ว',
			content3:'โกดังหลายแห่งตั้งอยู่ในพอร์ตการโหลดหลัก',
			title4:'ทีมงานมืออาชีพ',
			content4:'การพัฒนาอย่างมืออาชีพการผลิตทีมส่งออก',
			free1:'บริการ ที่กำหนดเอง',
			frcon1:'การรีไซเคิลโลหะหมายถึง การประมวลผลทางกายภาพ หรือทางกลของวัสดุ ที่มีประโยชน์แยกออกจากเศษโลหะเป็นผลิตภัณฑ์รีไซเคิลมันเป็นห่วงโซ่อุตสาหกรรมจากการรีไซเคิลการแยกชิ้นส่วนเพื่อรีไซเคิลอุตสาหกรรมรีไซเคิลโลหะได้สร้างห่วงโซ่อุตสาหกรรม ที่สมบูรณ์ และระบบนิเวศรีไซเคิลเมื่อเศรษฐกิจเกิดใหม่ค่อย ๆ นำเทคโนโลยี และไลฟ์สไตล์มาใช้คล้ายกับประเทศ OECD ความต้องการโลหะทั่วโลกในอนาคตจะเพิ่มขึ้น 3 ถึง 9 เท่าของปริมาณโลหะ ที่ใช้ทั่วโลกการรีไซเคิลผลิตภัณฑ์โลหะ ที่ซับซ้อนสามารถแก้ไข และรับมือกับความท้าทาย ที่เกิดขึ้นจากความต้องการโลหะ ที่เพิ่มขึ้น',
			free2:'ควบคุมคุณภาพ',
			frcon2:'อุปกรณ์รีไซเคิลโลหะส่วนใหญ่รวมถึงการบด และอุปกรณ์บดอุปกรณ์การคัดแยกอุปกรณ์ก่อนการรักษา และอุปกรณ์การประมวลผล ที่งอกใหม่ฯ ลฯอุปกรณ์ ที่แตกต่างกันมีบทบาทสำคัญในการเชื่อมโยง ที่แตกต่างกันของการรีไซเคิลโลหะอุปกรณ์เหล่านี้ ถูกใช้อย่างแพร่หลายในการประมวลผลเศษโลหะ และปรับปรุงการใช้ทรัพยากรครอบคลุมหลากหลายวิธีการทางเทคนิค เช่น การบดทางกายภาพการแยกแม่เหล็กแบนฯ ลฯ',
			free3:'สถานีเดียว',
			frcon3:'ศูนย์รีไซเคิลโลหะของ บริษัท ของเราเชี่ยวชาญในการจัดการขยะโลหะทุกชนิด และมุ่งมั่น ที่จะรีไซเคิล และการกลั่นโลหะหายากช่วงรีไซเคิลในร้านครอบคลุมโลกให้บริการ ที่สะดวก เช่น การวิเคราะห์ราคาใน ที่ตรง และการทำธุรกรรมเงินสดบริษัท ของเรามุ่งเน้นไป ที่ขยะโลหะสูง (90 % ) ซึ่งสามารถรีไซเคิลได้โดยไม่คำนึงถึงน้ำหนัก หรือรูปร่าง',
			free4:'การตรวจสอบบุคคล ที่สาม',
			frcon4:'นอกเหนือจากผลกระทบต่อสิ่งแวดล้อมของการทำเหมืองแร่โลหะ และการหลอมแร่ยังบริโภค 7 % ถึง 8 % ของแหล่งพลังงานในโลกการรีไซเคิลใช้พลังงานน้อยกว่า การผลิตโลหะหลักในขณะ ที่ลดผลกระทบโดยรวมในสถาน ที่ทำเหมืองการรีไซเคิลโลหะยังสามารถลดความต้องการของ ores เกรดต่ำหลีกเลี่ยงการทำเหมืองแร่โลหะ ที่มีค่าบางอย่าง ที่จะหายากในอนาคต',
			new1:'ข่าว',
			new2:'ข่าวของ บริษัท',
			new3:'ข่าวอุตสาหกรรม'
		},
		service:{
			ourservice:'บริการของเรา',
			questions:'คำถาม ที่พบบ่อย',
			message:'ฝากข้อความไว้',
			hours:'กรุณาฝากข้อความไว้เราจะตอบกลับคุณในอีก 24 ชั่วโมง',
			name:'ชื่อของคุณ:',
			mail:'อีเมล: *',
			tel:'โทร/ แอพอะไรอ่ะ :',
			type:'ประเภทสินค้า: *',
			video:'วิดีโอ',
			up:'หน้าสุดท้าย',
			next:'หน้าถัดไป'
		},
		contact:{
			help:'เรามา ที่นี่เพื่อช่วย',
			helpDesc:'ติดต่อเราผ่านข้อมูลการติดต่อต่อไปนี้',
			manager:'ตัวจัดการฝ่ายขาย',
			phone:'โทรศัพท์/ แอพอะไรคะ / พวกเราแชท',
			sendeamil:'ส่งอีเมล',
			ouraddress:'ที่อยู่ของเรา'
		}, 
		foot:{
			navigation:'นำทางด่วน',
			type:'หมวดหมู่',
			mobile:'มือถือ ( แอพอะไรอ่ะ / พวกเราแชท )',
			email:'อีเมล',
			address:'ที่อยู่',
			number:'หมายเลขแฟ้ม',
			service:'บริการหยุดเดียวการเลือกง่ายขึ้น'
		},
		product:{
			description:'คำอธิบาย',
			technical:'ข้อมูลทางเทคนิค',
			advantages:'ข้อดี',
			related:'ผลิตภัณฑ์ ที่เกี่ยวข้อง',
			videoDesc:'โรงงานผลิตโลหะผสมจากจีน ที่มีคุณภาพสูง ที่สุดในโลกในราคาต่ําสุดค่านายหน้า ที่สูงเกินไป',
			ti1:'โปรดกรอก ที่อยู่อีเมล',
			ti2:'กรุณากรอกประเภท',
			ti3:'โปรดกรอกเนื้อหา'
		},
		nav:{
			home:'ที่บ้าน',
			about:'เกี่ยวกับเรา',
			products:'ผลิตภัณฑ์',
			news:'ข่าว',
			video:'วิดีโอ',
			free:'รีไซเคิล และเทคโนโลยีฟรี',
			contact:'ติดต่อเรา',
			vr:'ไม่เป็นไรหรอก',
			chat:'คุย',
			whatsapp:'แอพอะไรอ่ะ',
			wechat:'พวกเราแชท',
			message:'ข้อความ',
			tel:'โทร',
			top:'ด้านบน',
		},
		btn:{
			read:'อ่านเพิ่มเติม',
			news:'ข่าวเพิ่มเติม',
			exhibition:'ข้อมูลเพิ่มเติม',
			watchVideo:'ดูวิดีโอเพิ่มเติม',
			services:'บริการ',
			products:'ผลิตภัณฑ์',
			contactus:'ติดต่อเรา',
			inquiry:'สอบถามรายละเอียดเพิ่มเติม',
			size:'ขนาด',
			packing:'การจัดเก็บ',
			service:'บริการออนไลน์',
			submit:'ส่งข้อมูล',
			sendEmial:'ส่งอีเมล',
			now:'สั่งเลยค่ะ',
			text1:'อย่าลังเล ที่จะติดต่อเราตลอดเวลา',
			text2:'เราออกแบบเนื้อหา และความละเอียดของวัสดุ ที่ตอบสนองความต้องการของคุณ',
			text3:'ไม่ว่า คุณจะต้องการเพิ่มความปลอดภัยกำลังการผลิต หรือความน่าเชื่อถือมาก ที่สุด หรือลดต้นทุนเราส่งมอบ',
			text4:'เราอุทิศตนเพื่อให้บริการลูกค้าพิเศษ และส่งมอบผลิตภัณฑ์คุณภาพสูงให้กับลูกค้า ที่มีมูลค่าของเรา',
			text5:'มุ่งเน้นไป ที่การผลิตเฟอร์โรซิลิคอน และซิลิคอนโลหะคุณภาพสูง',
			text6:'* เคล็ดลับ: 1.คุณต้องการผลิตภัณฑ์อะไร?2.คุณวางแผนจะทำโครงการอะไร?3.คุณจะต้องการผลิตภัณฑ์นี้ เมื่อใด'
		}
    }
};
